import { APICore } from 'helpers/api/apiCore'
import { APICoreWebSocket } from 'helpers/api/apiCoreWebSocket'
import { MensagemChatwootDto } from 'store/modules/kanban/types'

const api = new APICore()
const apiWs = new APICoreWebSocket()

export function getKanbanPipeline(
  pipelineId: string,
  clientesArquivados: boolean
) {
  return api.getWithoutUndefined(`Kanban/pipeline`, {
    pipelineId,
    clientesArquivados
  })
}

export function getCentrosDeCusto() {
  return api.get(`Generic/centros-custo`, null)
}

export function getPipelines(centroCustoId?: string) {
  return api.getWithoutUndefined(`Generic/pipelines`, {
    centroCustoId
  })
}

export interface CriarMotivoMovimentacaoDto {
  pipelineEtapaClienteId: string
  motivoId: string
  observacao: string
}

export function criarMotivoMovimentacao(data: CriarMotivoMovimentacaoDto) {
  return api.create(`Kanban/motivo-perda`, data)
}

export function getMotivosPerda() {
  return api.get(`Generic/motivo-pipeline`, null)
}

export interface MovimentacaoCardsDto {
  pipelineId: string
  pipelineEtapaOrigemId: string
  pipelineEtapaDestinoId: string
  pipelineEtapaClienteId: string
  clienteId: string
  ordem: number
}

export function movimentarCardKanban(data: MovimentacaoCardsDto) {
  return api.update(`Kanban/card`, data)
}

export function getInformacoesCardKanban(pipelineEtapaClienteId: string) {
  return api.get(`Kanban/informacoes-card`, { pipelineEtapaClienteId })
}

export function getConsultores(centroCustoId: string) {
  return api.get(`Generic/consultores`, { centroCustoId })
}

export interface AtribuirConsultorDto {
  pipelineId: string
  pipelineEtapaClienteId: string
  consultorId: string
  clienteId: string
}
export function atribuirConsultorCardKanban({
  pipelineId,
  pipelineEtapaClienteId,
  consultorId,
  clienteId
}: AtribuirConsultorDto) {
  return api.update(`Kanban/atribui-cliente-consultor`, {
    pipelineId,
    pipelineEtapaClienteId,
    consultorId,
    clienteId
  })
}

interface AnotacaoCardKanbanDto {
  pipelineEtapaClienteId: string
  descricao: string
}
export function criarAnotacaoCardKanban(value: AnotacaoCardKanbanDto) {
  return api.create(`Kanban/anotacoes`, value)
}

export function getAnotacoesCardKanban(pipelineEtapaClienteId: string) {
  return api.get(`Kanban/anotacoes`, { pipelineEtapaClienteId })
}

export function getBigNumbers(pipelineId: string) {
  return api.get(`Kanban/big-numbers`, {
    pipelineId
  })
}

export interface RegisterClienteDto {
  pipelineId: string
  nome: string
  cpf: string
  dataNascimento: string
  matricula?: string | null
  ddd: string
  telefone: string
  perfilId: string
  convenioId?: string | null
  margem?: number | null
  margemCartao?: number | null
  sessaoServidor?: boolean
  numeroNit?: number | null
}

export function cadastrarCliente(register: RegisterClienteDto) {
  return api.create(`Kanban/cadastro-simplificado-cliente`, register)
}

export function adicionarClienteKanban({
  pipelineId,
  cpf
}: {
  pipelineId: string
  cpf: string
}) {
  return api.create(`Kanban/cadastro-cliente`, {
    cpf,
    pipelineId
  })
}

export function getConvenios() {
  return api.get(`Generic/convenios`, null)
}

export function getPerfis() {
  return api.get(`Generic/perfis`, null)
}

export function getPipelineDefault() {
  return api.get(`Kanban/pipeline/site`, null)
}

export function getHierarquia() {
  return api.get(`Generic/hierarquia`, null)
}

export function getAgentesChatwoot() {
  return api.get(`ChatWoot/agentes`, null)
}
export function getConexoesChatwoot() {
  return api.get(`ChatWoot/inboxes`, null)
}
export function getAgenteSelecionado() {
  return api.get(`ChatWoot/verifica-agente-selecionado`, null)
}

interface MensagemChatwootKanbanDto extends MensagemChatwootDto {
  pipelineEtapaClienteId: string
}
export function enviarMensagemChatwoot(mensagem: MensagemChatwootKanbanDto) {
  return api.create(`ChatWoot/criar-mensagem`, mensagem)
}

export function getTiposAgendamento() {
  return api.get(`Generic/tipos-atendimento`, null)
}

interface CriarAgendamentoDto {
  pipelineEtapaClienteId: string
  dataAtendimento: string
  horario: string
  tipoAtendimentoId: string
  observacao: string
  ddd: string
  telefone: string
}

export function criarAgendamento(data: CriarAgendamentoDto) {
  return api.create(`Kanban/agendar-atendimento`, data)
}

export function iniciarRetornoKanban(eventName: string) {
  return apiWs.connectToHub('NotificacaoKanban', eventName)
}

export interface DiscarClienteKanbanDto {
  pipelineEtapaClienteId: string
  tipoLigacao: number
  telefoneId: string
}

export function discarCliente(data: DiscarClienteKanbanDto) {
  return api.create(`Kanban/discar`, data)
}

export function buscarGravacao(callId: string) {
  return api.get(`IntegracaoTelecom/buscar-gravacao`, {
    callId
  })
}
